<template>
  <div class="party-leaderboard-container animated fadeInRight">
    <el-card>
      <div slot="header" class="flex justify-between">
        <span>{{ $t('partyLeaderboard.list.title') }}</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input v-model="conditions.name" :placeholder="$t('partyLeaderboard.search.name')" />
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="_queryMethod()">{{ $t('common.search') }}</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card style="margin-top:20px">
      <el-table :data="leaderboard" border style="width:100%" v-loading="loading">
        <el-table-column :label="$t('partyLeaderboard.table.rank')" align="center" width="80">
          <template slot-scope="scope">
            <span :class="{'rank-top': scope.$index < 3}">{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$t('partyLeaderboard.table.name')" align="center" />
        <el-table-column :label="$t('partyLeaderboard.table.duration')" align="center">
          <template slot-scope="scope">
            {{ scope.row.durationHours || scope.row.duration || 0 }}{{ $t('common.hour') }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top:15px" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        layout="total, sizes, prev, pager, next, jumper" :total="page.total" />
    </el-card>
  </div>
</template>

<script>
import { listPartyLeaderboard } from '@/api/party/partyLeaderboardApi'

export default {
  name: 'PartyLeaderboardList',
  data() {
    return {
      loading: false,
      leaderboard: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      conditions: {
        name: ''
      }
    }
  },
  created() {
    this._listLeaderboard()
  },
  methods: {
    async _listLeaderboard() {
      try {
        this.loading = true
        const params = {
          ...this.conditions,
          page: this.page.current,
          row: this.page.size
        }
        const { data, total } = await listPartyLeaderboard(params)
        this.leaderboard = data || []
        this.page.total = total || 0
      } catch (error) {
        this.$message.error(this.$t('partyLeaderboard.fetchError'))
      } finally {
        this.loading = false
      }
    },
    _queryMethod() {
      this.page.current = 1
      this._listLeaderboard()
    },
    handleSizeChange(val) {
      this.page.size = val
      this._listLeaderboard()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listLeaderboard()
    }
  }
}
</script>

<style lang="scss" scoped>
.party-leaderboard-container {
  padding: 20px;

  .rank-top {
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 50%;
    color: #fff;
    background: #e6a23c;
    font-weight: bold;
  }
}
</style>
